import { datadogLogs } from '@datadog/browser-logs';

import { clientEnvVars } from './common/environment/clientEnvVars';

/**
 * Override console log with DataDog SDK.
 */
const dataDogClientToken: string = clientEnvVars().DATADOG_CLIENT_TOKEN;
if (dataDogClientToken !== null) {
  datadogLogs.init({
    clientToken: dataDogClientToken,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: clientEnvVars().DATADOG_SERVICE_NAME,
  });

  const logger = datadogLogs.logger;

  /* tslint:disable:no-console */
  console.debug = logger.debug.bind(logger);
  console.log = logger.log.bind(logger);
  console.info = logger.info.bind(logger);
  console.warn = logger.warn.bind(logger);
  console.error = logger.error.bind(logger);
  /* tslint:enable:no-console */
}
